import React from 'react';
import PriceFilter from 'component/page/search/SortAndFilter/Filter/PriceFilter';
import CheckboxFilter from 'component/page/search/SortAndFilter/Filter/CheckboxFilter';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import StarRatingFilter from 'component/page/search/SortAndFilter/Filter/StarRatingFilter';
import { ValueFilterEvents, RangeFilter, ValueFilter, RangeFilterEvents, PriceFilterType } from 'core/type/Filter.types';
import { Box } from '@drone-js/core';
import { FeatureName } from 'core/constant/FeatureName';
import Feature from 'component/common/Experiment/Feature';

export interface Props extends ValueFilterEvents, RangeFilterEvents {
    visible: boolean;
    priceFilter?: PriceFilterType;
    starRatingFilter: RangeFilter[];
    durationFilter: ValueFilter[];
    bookingFeatureFilter: ValueFilter[];
    cms: CmsValue;
    isSidebar: boolean;
    isLoading: boolean;
}

const FilterContainer: React.FC<Props> = React.memo((props) => {
    if (!props.visible) {
        return null;
    }
    return (
        <Box px="16" data-testid="activities-filter-container">
            {props.priceFilter && (
                <PriceFilter
                    key={props.priceFilter.max}
                    filter={props.priceFilter}
                    onRangeFilterChange={props.onRangeFilterChange}
                    isSidebar={props.isSidebar}
                    isLoading={props.isLoading}
                />
            )}
            <StarRatingFilter
                elementName="activities-filter-star-rating"
                title={props.cms[146543]}
                items={props.starRatingFilter}
                onRangeFilterChange={props.onRangeFilterChange}
                isSidebar={props.isSidebar}
            />
            <Feature.On name={FeatureName.NewFilters}>
                <CheckboxFilter
                    elementName="activities-filter-booking-feature"
                    title={props.cms[411347]}
                    items={props.bookingFeatureFilter}
                    onValueFilterChange={props.onValueFilterChange}
                    isSidebar={props.isSidebar}
                />
            </Feature.On>
            <CheckboxFilter
                elementName="activities-filter-duration"
                title={props.cms[146544]}
                items={props.durationFilter}
                onValueFilterChange={props.onValueFilterChange}
                isSidebar={props.isSidebar}
            />
        </Box>
    );
});
FilterContainer.displayName = 'FilterContainer';

export default FilterContainer;
